const emit = (el, value) => {
    el.dispatchEvent(new CustomEvent('input', { bubbles: true, detail: value }));
    el.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: value }));
};

/**
 * <mellow-toggle>: a toggle button (aria-pressed). `.value` is a boolean for wire:model.
 */
export class MellowToggle extends HTMLElement {
    connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.addEventListener('click', (event) => {
            const button = event.target.closest('button');
            if (!button || button.disabled) return;
            this.value = !this.value;
            emit(this, this.value);
        });
    }

    get button() {
        return this.querySelector('button');
    }

    get value() {
        return this.button?.getAttribute('aria-pressed') === 'true';
    }

    set value(value) {
        this.button?.setAttribute('aria-pressed', String(Boolean(value)));
    }
}

/**
 * <mellow-toggle-group type="single|multiple">: `.value` is the pressed button's value
 * (single) or an array of values (multiple).
 */
export class MellowToggleGroup extends HTMLElement {
    connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.addEventListener('click', (event) => {
            const button = event.target.closest('button[data-value]');
            if (!button || button.disabled) return;

            const pressed = button.getAttribute('aria-pressed') === 'true';
            if (!this.multiple) {
                this.buttons.forEach((b) => b.setAttribute('aria-pressed', 'false'));
            }
            button.setAttribute('aria-pressed', String(!pressed));
            emit(this, this.value);
        });
    }

    get multiple() {
        return this.getAttribute('type') === 'multiple';
    }

    get buttons() {
        return [...this.querySelectorAll('button[data-value]')];
    }

    get value() {
        const values = this.buttons.filter((b) => b.getAttribute('aria-pressed') === 'true').map((b) => b.dataset.value);
        return this.multiple ? values : (values[0] ?? '');
    }

    set value(value) {
        const values = (Array.isArray(value) ? value : [value]).filter((v) => v !== null && v !== undefined && v !== '').map(String);
        this.buttons.forEach((b) => b.setAttribute('aria-pressed', String(values.includes(b.dataset.value))));
    }
}
